import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    tel: '',
  },
  mutations: {
    changetoken(state, token) {
      state.token = token;
    },
    changetel(state, tel) {
      state.tel = tel;
    },
  },
  actions: {
    // changeSgin2(state) {
    //   state.newSign = 2
    // }
  },
  modules: {
  }
})


